// extracted by mini-css-extract-plugin
module.exports = {"ratingWrp":"slider_ratingWrp__AKhzd","ratingTextWrp":"slider_ratingTextWrp__3O_Vl","ratingLabel":"slider_ratingLabel__2LcBf"};